import { Component } from '@angular/core';
import { SortService } from '@syncfusion/ej2-angular-grids';
import { Subject, take } from 'rxjs';
import { GeneralService } from 'src/app/services/general.service';
import { ASLicenseSettings } from 'src/app/Shared/model/GeneralModel';
import { SYNCFUSION_MODULES } from 'src/app/Shared/shared-imports';

@Component({
  selector: 'app-ops-vendor-weekly-rental',
  standalone: true,
  imports: [SYNCFUSION_MODULES],
  providers: [SortService],
  templateUrl: './ops-vendor-weekly-rental.html',
  styleUrl: './ops-vendor-weekly-rental.scss'
})

export class OpsVendorWeeklyRental {

  private destroy$ = new Subject<void>();
  noLayout = false;

  constructor(
    private generalService: GeneralService
  ) { }

  ngOnInit(): void {
    this.getASCloudLicenseSettings();
  }

  getASCloudLicenseSettings(): void {
    const licenseSettings = this.generalService.ASLicenseSettings;
    if (licenseSettings !== null) {
      this.noLayout = licenseSettings.NoLayout ?? false;
      return;
    }

    this.generalService.getASCloudLicenseSettings().pipe(take(1)).subscribe({
      next: (res: ASLicenseSettings) => {
        this.generalService.ASLicenseSettings = res;
        this.noLayout = res.NoLayout ?? false;
      },
      error: () => {
        this.noLayout = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
